<template>
  <div>
    <div class="content-box">
      <div class="container-fluid" v-infinite-scroll="fetchListPage" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <div
          class="row row-item"
          v-for="item in attendeeList"
          :key="'item-' + item.id"
          @click="openParticipant(item)"
        >
          <div class="col-auto">
            <div class="avatar-box">
              <div class="avatar-initials">
                {{ getInitials(item.name) }}
              </div>
            </div>
          </div>
          <div class="col texts-box text-truncate">
            <div class="text-1 text-truncate">{{ item.name }}</div>
            <div class="text-2 text-truncate">{{ item.email }}</div>
          </div>
          <div class="col-auto">
            <i class="bx bx-chevron-right chevron-icon"></i>
          </div>
        </div>
        <div v-if="attendeeList.length === 0 && !busy" class="text-center py-4 text-muted">
          Nenhum participante encontrado
        </div>
        <div v-if="busy" class="text-center py-4">
          <b-spinner variant="primary" small></b-spinner>
          <span class="ms-2">Carregando...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import { fetchParticipants } from '@/modules/storage/service/storageService'

export default {
  name: 'index-list',
  directives: { infiniteScroll: infiniteScroll },
  data: function () {
    return {
      pagination: {
        currentPage: 0,
        perPage: 30,
        totalPages: 0
      },
      attendeeList: [],
      busy: false,
      currentFilter: {
        search: null
      }
    }
  },
  methods: {
    getInitials: function (name) {
      if (!name) return '?'
      var parts = name.split(' ')
      if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase()
      }
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
    },
    openParticipant: function (item) {
      this.$emit('open-participant', {
        id: item.id,
        name: item.name,
        email: item.email,
        document: item.document,
        group: item.group
      })
    },
    filter: function (search) {
      this.currentFilter.search = search
      this.resetList()
      this.fetchListPage()
    },
    fetchListPage: function () {
      var self = this

      // Se já carregou todas as páginas, não faz nada
      if (self.pagination.totalPages !== 0 && self.pagination.totalPages === self.pagination.currentPage) {
        self.busy = false
        return
      }

      self.busy = true

      var params = {
        limit: self.pagination.perPage,
        page: self.pagination.currentPage + 1
      }

      if (self.currentFilter.search) {
        params.search = self.currentFilter.search
      }

      fetchParticipants(params)
        .then(function (response) {
          self.busy = false
          self.pagination.currentPage = response.meta.pagination.current_page
          self.pagination.totalPages = response.meta.pagination.total_pages

          var items = response.data.map(function (item) {
            return {
              id: item.id + '',
              name: item.name,
              email: item.email,
              cpf: item.cpf,
              group: item.group ? item.group.name : null
            }
          })

          self.attendeeList.push.apply(self.attendeeList, items)
        })
        .catch(function (error) {
          self.busy = false
          console.error('Erro ao carregar participantes:', error)
        })
    },
    resetList: function () {
      this.attendeeList = []
      this.pagination.currentPage = 0
      this.pagination.totalPages = 0
    }
  },
  created: function () {
    this.pagination.currentPage = 0
    this.pagination.totalPages = 0
    this.fetchListPage()
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";

.chevron-icon {
  font-size: 22px;
  color: #74788d;
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 23px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(233, 233, 233, 0.59);
  align-items: center;
  cursor: pointer;

  &:hover {
    border-color: #556ee6;
    box-shadow: 0 0 5px rgba(85, 110, 230, 0.2);
  }
}

.avatar-box {
  --width: 35px;
  --height: 35px;
  --font-size: 14px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 50px;
    --height: 50px;
    --font-size: 18px;
  }

  .avatar-initials {
    width: var(--width);
    height: var(--height);
    border-radius: 6px;
    display: grid;
    place-items: center;
    background-color: #556ee6;
    color: #ffffff;
    font-size: var(--font-size);
    font-weight: 600;
  }
}

.texts-box {
  .text-1 {
    font-size: 16px;
    color: #05162B;
    font-weight: 500;
  }

  .text-2 {
    font-size: 14px;
    color: #05162B87;
  }
}
</style>
